<div class="form-group" [formGroup]="formGroup">
  <div class="group" (focusout)="isTouched = true">

    <input type="hidden" *ngIf="controlName" [formControlName]='controlName' [required]="required">
    <input type="hidden" *ngIf="!controlName" [(value)]="selectedDate">

    <input readonly
      class="input-control datepicker"
      [ngClass]="{'no-icon': noIcon, 'ng-invalid ng-dirty': hasError()}"
      [disabled]="disabled"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [(ngModel)]="selectedDate" [ngModelOptions]="{standalone: true}"
      (dateSelect)="setFieldControlValue()"
      [footerTemplate]="footerTemplate"
      [placement]="placement"
      placeholder=""
      ngbDatepicker #dp="ngbDatepicker" (click)="!disabled ? dp.toggle() : null">
    <label class="floating-label" (click)="!disabled ? dp.toggle() : null">
      {{label | translate}}
    </label>
    <div class="suffix">
      <button class="btn border-0 font-14"
        *ngIf="selectedDate" (click)="selectedDate = null; setFieldControlValue()">
        <span>✖</span>
      </button>
    </div>
    @if (!noIcon) {
      <svg class="form-control-icon with-fill" width="18" height="19" viewBox="0 0 18 19"
      fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.8 7.5V7.7H14C15.0078 7.7 15.9744 8.10036 16.687 8.81299C17.3996 9.52563 17.8 10.4922 17.8 11.5V16.5C17.8 16.9774 17.6104 17.4352 17.2728 17.7728C16.9352 18.1104 16.4774 18.3 16 18.3H2C1.52261 18.3 1.06477 18.1104 0.727208 17.7728C0.389642 17.4352 0.2 16.9774 0.2 16.5V11.5C0.2 10.4922 0.600356 9.52563 1.31299 8.81299C2.02563 8.10036 2.99218 7.7 4 7.7H4.2V7.5V4.7H5.8V7.5V7.7H6H8H8.2V7.5V4.7H9.8V7.5V7.7H10H12H12.2V7.5V4.7H13.8V7.5ZM1.8 12.5V12.7H2H16H16.2V12.5V11.5C16.2 10.9165 15.9682 10.3569 15.5556 9.94437C15.1431 9.53179 14.5835 9.3 14 9.3H4C3.41652 9.3 2.85694 9.53179 2.44437 9.94437C2.03179 10.3569 1.8 10.9165 1.8 11.5V12.5ZM2 14.3H1.8V14.5V16.5V16.7H2H16H16.2V16.5V14.5V14.3H16H2ZM4.2 1.68322C4.44406 1.64197 4.67119 1.52587 4.84853 1.34853C5.02091 1.17615 5.13543 0.956715 5.17959 0.720418C5.32464 0.753836 5.45874 0.827371 5.56569 0.934314C5.71571 1.08434 5.8 1.28783 5.8 1.5V2.5C5.8 2.71217 5.71571 2.91566 5.56569 3.06569C5.41566 3.21571 5.21217 3.3 5 3.3C4.78783 3.3 4.58434 3.21571 4.43431 3.06569C4.28429 2.91566 4.2 2.71217 4.2 2.5V1.68322ZM8.2 1.68322C8.44406 1.64197 8.67119 1.52587 8.84853 1.34853C9.02091 1.17615 9.13543 0.956715 9.17959 0.720418C9.32464 0.753836 9.45874 0.827371 9.56569 0.934314C9.71571 1.08434 9.8 1.28783 9.8 1.5V2.5C9.8 2.71217 9.71571 2.91566 9.56569 3.06569C9.41566 3.21571 9.21217 3.3 9 3.3C8.78783 3.3 8.58434 3.21571 8.43431 3.06569C8.28429 2.91566 8.2 2.71217 8.2 2.5V1.68322ZM12.2 1.68322C12.4441 1.64197 12.6712 1.52587 12.8485 1.34853C13.0209 1.17615 13.1354 0.956715 13.1796 0.720418C13.3246 0.753836 13.4587 0.827371 13.5657 0.934314C13.7157 1.08434 13.8 1.28783 13.8 1.5V2.5C13.8 2.71217 13.7157 2.91566 13.5657 3.06569C13.4157 3.21571 13.2122 3.3 13 3.3C12.7878 3.3 12.5843 3.21571 12.4343 3.06569C12.2843 2.91566 12.2 2.71217 12.2 2.5V1.68322Z"
            fill="#DADADA" stroke="white" stroke-width="0.4" />
      </svg>
    }
  </div>
  <div class="has-error" *ngIf="hasError('required')">
      {{'form.required field' | translate}}
  </div>
  <div class="has-error" *ngIf="hasError('invalid')">
    {{ invalidMsg || ('form.Invalid Date' | translate) }}
  </div>

  <ng-template #footerTemplate>
    <hr class="my-0">
    <div class="p-3 d-flex justify-content-between align-items-center">
      <button class="btn btn-primary btn-sm" *ngIf="showToday" type="button" [disabled]="disabled" (click)="setDate(today); dp.close()">{{ 'general.Today' | translate }}</button>
      <button class="btn btn-secondary btn-sm" type="button" [disabled]="disabled" (click)="setDate(); dp.close()" *ngIf="!isView">{{ 'general.Clear' | translate }}</button>
    </div>
  </ng-template>
</div>
